import { SubmitButton } from "components/common/buttons/SubmitButton";
import { ArrowLeft } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const JoinInterpreterVideoCall = () => {
  const { id } = useParams();
  const iframeUrl = useSelector(
    (state) => state.interpreterIframe.interpreterIframeUrl
  );
  const navigate = useNavigate();

  React.useEffect(() => {
    console.log("iframeUrl:", iframeUrl);
  }, [iframeUrl]);

  const handleBack = () => {
    if (id) {
      return navigate(`/interpreter/appointments/view/${id}`);
    }
    navigate(-1);
  };

  return (
    <div className="content position-relative">
      <div className="position-absolute">
        <SubmitButton
          buttonType="button"
          icon={<ArrowLeft />}
          btnText="Back"
          handleSubmit={handleBack}
        />
      </div>
      <div
        className="container d-flex flex-column mx-auto align-items-center justify-content-center bg-light p-0"
        style={{ width: "85%", height: "82vh", overflow: "hidden" }}
      >
        {iframeUrl ? (
          <iframe
            title="100ms-app"
            allow="camera *;microphone *;display-capture *"
            src={iframeUrl}
            className="w-100 h-100 border-0"
          ></iframe>
        ) : (
          <p>No video call in progress.</p>
        )}
      </div>
    </div>
  );
};

export default JoinInterpreterVideoCall;
